import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../../store';

export const LastResultsCont = observer(() => {
  const { pastRoundsData } = gameStore;

  const history = useMemo(() => {
    return pastRoundsData.map((item) => ({
      anim: item.anim,
      roundId: item.roundId,
      number: item.roundData.reduce((acc, current) => acc + current, 0),
    }));
  }, [pastRoundsData]);

  return (
    <div className='magic-dice-numbers-wr-holder'>
      <div className='magic-dice-numbers-wr'>
        {history.map(({ number, roundId }, index) => (
          <div className={`magic-dice-number ${!index ? 'active' : ''}`} key={`${roundId}_${index}`}>
            {number}
          </div>
        ))}
      </div>
    </div>
  );
});
